/**
 * Formats a byte count as a human-readable size string (NPJB-369) — used by
 * the AI Brief composer's per-file size caption and toolbar counter.
 *
 * Fix round 2: the common case — a sub-1MB PDF or screenshot — used to divide
 * by 1MB unconditionally and round to "0.0 MB" for everything under ~50KB,
 * which reads as broken. Below the 1 MiB boundary this now scales to KB;
 * at/above it, MB (one decimal place either way). Matches the binary-MB
 * convention `brief-file-gates.ts` already uses for
 * `MAX_BRIEF_FILE_SIZE_BYTES` (25 * 1024 * 1024).
 */
const BYTES_PER_KB = 1024;
const BYTES_PER_MB = 1024 * 1024;

export const formatFileSize = (bytes: number): string =>
  bytes < BYTES_PER_MB
    ? `${(bytes / BYTES_PER_KB).toFixed(1)} KB`
    : `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
